import { v5 } from 'uuid';
import { normalizeValue } from './normalizeValue';

const stableIdNamespace = '93592934-2d69-4f5f-857c-bd24d74ef2d2';

export function stableId(id?: string): string {
	const normalized = normalizeValue(id) || '';
	return v5(normalized, stableIdNamespace);
}
